import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import { customStyles } from '../../../../helpers/modal_styles';
import { onEditarCliente } from '../../../../services/clientes/clientesService';
import './ClientesEditModal.css';

export const ClientesEditModal = ({
    setModalEditar,
    modalEditar,
    editar,
    onReload
}) => {
    const dispatch = useDispatch();
    Modal.setAppElement("#root");

    const [formValues, setFormValues] = useState({
        id: '',
        razon_social: '',
        nit: '',
        div: '',
        telefono: '',
        nombre_representante: '',
        gran_contribuyente: false,
        comentarios: '',
        estado: 1,
        contador_nombre: '',
        regimen: '',
        tipo_membresia: '',
        ciudades: ''
    });

    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (editar && editar.id) {
            setFormValues({
                id: editar.id,
                razon_social: editar.razon_social || '',
                nit: editar.nit || '',
                div: editar.div || '',
                telefono: editar.telefono || '',
                nombre_representante: editar.nombre_representante || '',
                gran_contribuyente: editar.gran_contribuyente === 1 || editar.gran_contribuyente === true,
                comentarios: editar.comentarios || '',
                estado: editar.estado !== undefined ? editar.estado : 1,
                contador_nombre: editar.contador_nombre || '',
                regimen: editar.regimen || '',
                tipo_membresia: editar.tipo_membresia || '',
                ciudades: editar.ciudades || ''
            });
            setErrors({});
        }
    }, [editar]);

    const closeModal = () => {
        setModalEditar(false);
        setErrors({});
    };

    const validateFields = () => {
        const newErrors = {};

        if (!formValues.razon_social?.trim()) {
            newErrors.razon_social = 'La razón social es requerida';
        }

        if (!formValues.nit?.trim()) {
            newErrors.nit = 'El NIT es requerido';
        }

        if (!formValues.telefono?.trim()) {
            newErrors.telefono = 'El teléfono es requerido';
        }

        if (!formValues.nombre_representante?.trim()) {
            newErrors.nombre_representante = 'El nombre del representante es requerido';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateFields()) {
            return;
        }

        try {
            const resultado = await dispatch(
                onEditarCliente(
                    formValues.id,
                    formValues.razon_social,
                    formValues.nit,
                    formValues.div,
                    formValues.telefono,
                    formValues.nombre_representante,
                    formValues.gran_contribuyente,
                    formValues.comentarios,
                    formValues.estado
                )
            );

            // Verificar si la respuesta fue exitosa
            if (resultado && resultado.ok) {
                Swal.fire('Éxito', resultado.msg || 'Cliente actualizado correctamente', 'success');
                closeModal();
                onReload();
            } else if (resultado && resultado.msg) {
                // Si ok es false pero hay un mensaje, mostrar como error
                Swal.fire('Error', resultado.msg, 'error');
            } else if (resultado && resultado.errors) {
                // Si hay errores de validación
                const errorMsg = resultado.errors[0]?.msg || 'Error al guardar los cambios';
                Swal.fire('Error', errorMsg, 'error');
            } else {
                Swal.fire('Error', 'Error al guardar los cambios', 'error');
            }
        } catch (error) {
            console.log('Error:', error);
            Swal.fire('Error', 'Error al guardar los cambios', 'error');
        }
    };

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormValues({
            ...formValues,
            [name]: type === 'checkbox' ? checked : value
        });
    };

    const handleEstadoChange = (e) => {
        setFormValues({
            ...formValues,
            estado: e.target.checked ? 1 : 0
        });
    };

    return (
        <Modal
            isOpen={modalEditar}
            onRequestClose={closeModal}
            style={customStyles}
            contentLabel="Editar Cliente"
        >
            <div className="popup">
                <center>
                    <h3>Editar Cliente</h3>
                </center>
                <br />
                <form onSubmit={handleSubmit}>
                    <div className="form-group-custom">
                        <label><strong>Razón Social</strong></label>
                        <input
                            type="text"
                            name="razon_social"
                            className={`input-custom ${errors.razon_social ? 'input-error' : ''}`}
                            value={formValues.razon_social}
                            onChange={handleInputChange}
                        />
                        {errors.razon_social && (
                            <div className="error-message">
                                {errors.razon_social}
                            </div>
                        )}
                    </div>

                    <div className="form-row-custom">
                        <div className="form-group-custom">
                            <label><strong>NIT</strong></label>
                            <input
                                type="text"
                                name="nit"
                                className={`input-custom ${errors.nit ? 'input-error' : ''}`}
                                value={formValues.nit}
                                onChange={handleInputChange}
                            />
                            {errors.nit && (
                                <div className="error-message">
                                    {errors.nit}
                                </div>
                            )}
                        </div>
                        <div className="form-group-custom">
                            <label><strong>DV</strong></label>
                            <input
                                type="text"
                                name="div"
                                className="input-custom"
                                value={formValues.div}
                                onChange={handleInputChange}
                                placeholder="Dígito verificador"
                            />
                        </div>
                    </div>

                    <div className="form-row-custom">
                        <div className="form-group-custom">
                            <label><strong>Teléfono</strong></label>
                            <input
                                type="text"
                                name="telefono"
                                className={`input-custom ${errors.telefono ? 'input-error' : ''}`}
                                value={formValues.telefono}
                                onChange={handleInputChange}
                            />
                            {errors.telefono && (
                                <div className="error-message">
                                    {errors.telefono}
                                </div>
                            )}
                        </div>
                        <div className="form-group-custom">
                            <label><strong>Nombre Representante</strong></label>
                            <input
                                type="text"
                                name="nombre_representante"
                                className={`input-custom ${errors.nombre_representante ? 'input-error' : ''}`}
                                value={formValues.nombre_representante}
                                onChange={handleInputChange}
                            />
                            {errors.nombre_representante && (
                                <div className="error-message">
                                    {errors.nombre_representante}
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="form-row-custom">
                        <div className="form-group-custom">
                            <label><strong>Contador</strong></label>
                            <input
                                type="text"
                                className="input-custom"
                                value={formValues.contador_nombre}
                                disabled
                            />
                            <small>Solo lectura</small>
                        </div>
                        <div className="form-group-custom">
                            <label><strong>Ciudades</strong></label>
                            <input
                                type="text"
                                className="input-custom"
                                value={formValues.ciudades}
                                disabled
                            />
                            <small>Solo lectura</small>
                        </div>
                    </div>

                    <div className="form-row-custom">
                        <div className="form-group-custom">
                            <label><strong>Régimen</strong></label>
                            <input
                                type="text"
                                className="input-custom"
                                value={formValues.regimen}
                                disabled
                            />
                            <small>Solo lectura</small>
                        </div>
                    </div>

                    <div className="form-row-custom">
                        <div className="form-group-custom">
                            <label><strong>Tipo de Membresía</strong></label>
                            <input
                                type="text"
                                className="input-custom"
                                value={formValues.tipo_membresia}
                                disabled
                            />
                            <small>Solo lectura</small>
                        </div>
                        <div className="form-group-custom">
                            <label><strong>Gran Contribuyente</strong></label>
                            <div className="estado-toggle">
                                <label className="checkbox-label">
                                    <input
                                        type="checkbox"
                                        name="gran_contribuyente"
                                        checked={formValues.gran_contribuyente}
                                        onChange={handleInputChange}
                                        className="estado-checkbox"
                                    />
                                    <span className="checkbox-text">
                                        {formValues.gran_contribuyente ? "Sí" : "No"}
                                    </span>
                                </label>
                            </div>
                        </div>
                    </div>

                    <div className="form-group-custom">
                        <label><strong>Comentarios</strong></label>
                        <textarea
                            name="comentarios"
                            className="input-custom"
                            value={formValues.comentarios}
                            onChange={handleInputChange}
                            rows="3"
                            style={{ resize: 'vertical' }}
                        />
                    </div>

                    <div className="form-group-custom">
                        <label><strong>Estado</strong></label>
                        <div className="estado-toggle">
                            <label className="checkbox-label">
                                <input
                                    type="checkbox"
                                    name="estado"
                                    checked={formValues.estado === 1}
                                    onChange={handleEstadoChange}
                                    className="estado-checkbox"
                                />
                                <span className="checkbox-text">
                                    {formValues.estado === 1 ? "Activo" : "Inactivo"}
                                </span>
                            </label>
                        </div>
                    </div>

                    <div className="button-group">
                        <button type="submit" className="btn btn-primary">
                            Guardar Cambios
                        </button>
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={closeModal}
                        >
                            Cancelar
                        </button>
                    </div>
                </form>
            </div>
        </Modal>
    );
};
